import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/home/view';
import Auth from './pages/auth/view';
import UserDataPlayer from './pages/userdata/player/view';
import UserDataPrivate from './pages/userdata/private/view';
import UserDataRoaster from './pages/userdata/roaster/view';
import { AuthProvider } from './hooks/context/AuthContext';
import ProtectedRoute from './routes/ProtectedRoutes';
import NoRoutes from './pages/error/noRoutes';
import MainFuncView from './pages/inference/recommend/view';
import UserDataHistory from './pages/userdata/history/view';
import { ScreenWidthProvider } from './ScreenWidthContext';
import LandingView from './pages/landing/view';
import { logout } from './apis/authApis';

function App() {
  useEffect(() => {
    const handleBeforeUnload = async (event: any) => {
      // 로그아웃 로직 (예: API 호출)
      if (localStorage.getItem('accessToken')) {
        await logout({
          accessToken: localStorage.getItem('accessToken') || '',
        });

        // 사용자에게 경고 메시지를 보여줌 (선택 사항)
        event.preventDefault();
        event.returnValue = ''; // 이 설정이 있어야 경고 창이 표시됨
      } else {
        return;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <Router basename='/'>
      <AuthProvider>
        <ScreenWidthProvider>
          <div className="App">
            <Routes>
              <Route path="/" element={<LandingView />} />
              <Route
                path="/home"
                element={<ProtectedRoute element={<Home />} />}
              />
              <Route path="/auth" element={<Auth />} />
              <Route
                path="/dashboard"
                element={<ProtectedRoute element={<MainFuncView />} />}
              />
              <Route
                path="/userdata/history"
                element={<ProtectedRoute element={<UserDataHistory />} />}
              />
              <Route
                path="/userdata/player"
                element={<ProtectedRoute element={<UserDataPlayer />} />}
              />
              <Route
                path="/userdata/private"
                element={<ProtectedRoute element={<UserDataPrivate />} />}
              />
              <Route
                path="/userdata/roaster"
                element={<ProtectedRoute element={<UserDataRoaster />} />}
              />
              <Route path="*" element={<NoRoutes />} />
            </Routes>
          </div>
        </ScreenWidthProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
